import { AIBrandLogo } from "@/components/qorum/AIBrandLogo";
import type { Spokesperson } from "@/hooks/use-post-verdict";

export function SpokespersonPresence({ spokesperson }: { spokesperson: Spokesperson }) {
  return (
    <section
      data-testid="spokesperson-presence"
      data-rp="spokesperson-presence"
      aria-label={`Vous parlez avec ${spokesperson.name}, ${spokesperson.role}. Je vous écoute, Président.`}
      style={{ marginBottom: 56, textAlign: "center" }}
    >
      <div
        data-testid="spokesperson-avatar"
        style={{
          width: 96,
          height: 96,
          borderRadius: "50%",
          background: spokesperson.color,
          color: "var(--gold-light)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: '"Fraunces", serif',
          fontWeight: 900,
          fontSize: 42,
          fontVariationSettings: "'opsz' 144, 'SOFT' 30",
        }}
      >
        {spokesperson.initial}
      </div>
      <h1
        style={{
          fontFamily: '"Playfair Display", serif',
          fontWeight: 900,
          fontSize: 36,
          color: "var(--charcoal)",
          margin: "18px 0 0",
          letterSpacing: -0.5,
        }}
      >
        {spokesperson.name}
      </h1>
      <div
        style={{
          fontFamily: '"Cormorant Garamond", serif',
          fontStyle: "italic",
          fontSize: 20,
          color: "var(--leather)",
          marginTop: 4,
        }}
      >
        {spokesperson.role}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          marginTop: 8,
          color: "var(--gold-deep)",
        }}
      >
        <AIBrandLogo provider={spokesperson.aiProvider} size={14} />
        <span
          style={{
            fontFamily: '"DM Mono", monospace',
            fontSize: 10,
            letterSpacing: 3,
            textTransform: "uppercase",
            color: "var(--gold-deep)",
          }}
        >
          {spokesperson.model}
        </span>
      </div>
      <div
        style={{
          fontFamily: '"Caveat", cursive',
          fontSize: 26,
          color: "var(--gold-deep)",
          marginTop: 24,
        }}
      >
        Je vous écoute, Président.
      </div>
    </section>
  );
}

export default SpokespersonPresence;
